import { selectCommonEmptyGraphTemplateLinks } from 'components/Graph/EmptyGraph/selectors/selectCommonEmptyGraphTemplateLinks';
import { useGraphContextSelectors } from 'components/Graph/GraphContext';
import { InfoIcon } from 'components/icons/InfoIcon';
import { useLocale } from 'containers/App/LocaleContext';
import type { FC } from 'react';

export const DefaultEmptyContent: FC = () => {
  const msg = useLocale();
  const ctxProps = useGraphContextSelectors({
    templateLinks: selectCommonEmptyGraphTemplateLinks,
  });
  return (
    <>
      <p className='text-bold text-uppercase'>
        <InfoIcon title={null} className='mr-2.5 align-baseline inline' />
        {msg.canvasGraph.emptyGraph.defaultEmptyContent.title}
      </p>
      {msg.canvasGraph.emptyGraph.defaultEmptyContent.description(
        ctxProps.templateLinks,
      )}
    </>
  );
};
